import { AttributeOptions, IngressRequestForm } from '@dispatch/shared/types';
import { SubSection } from '@dispatch/web/ui';
import {
  Control,
  FieldValues,
  useFieldArray,
  UseFormGetValues,
  UseFormWatch,
} from 'react-hook-form';
import { Divider } from '@mui/material';
import { IngressClaimAttributesAdd } from './IngressClaimAttributesAdd';
import { IngressClaimAttributesForm } from './IngressClaimAttributesForm';

export type IngressClaimAttributesSectionProps = {
  control: Control<FieldValues>;
  watch: UseFormWatch<IngressRequestForm>;
  getValues: UseFormGetValues<IngressRequestForm>;
  companyAttributes: AttributeOptions[];
  isReview?: boolean;
};

export function IngressClaimAttributesSection({
  control,
  watch,
  getValues,
  companyAttributes,
  isReview,
}: IngressClaimAttributesSectionProps) {
  const { fields, remove, append } = useFieldArray({
    control,
    name: 'claimAttributes',
  });

  return (
    <div
      style={{
        padding: '24px',
      }}
    >
      <SubSection title={'Claim Attributes'}>
        <>
          <IngressClaimAttributesAdd
            append={append}
            control={control}
            watch={watch}
            companyAttributes={companyAttributes}
            isReview={isReview}
          />
          <Divider />
        </>

        {fields.map((field, index) => {
          return (
            <IngressClaimAttributesForm
              control={control}
              claimAttributeIndex={index}
              claimAttributeRemove={remove}
              field={field}
              getValues={getValues}
              companyAttributes={companyAttributes}
              isReview={isReview}
            />
          );
        })}
      </SubSection>
    </div>
  );
}
